"use client";

import React from "react";
import { HeartHandshake, Stethoscope, UserPlus, Syringe, Building2, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "\xA0Chiropractic",
  description: "Our lead specialists focusing on spinal health and structural alignment for athletes and families across our Limassol clinic.",
  icon: HeartHandshake,
  link: "/AboutBodywerksPage"
}, {
  title: "Acupuncture & Recovery",
  description: "Expert clinical acupuncture focused on holistic recovery, chronic pain management, and specialized cosmetic treatments.",
  icon: Stethoscope,
  link: "/ConditionTreatmentPage"
}, {
  title: "Therapeutic Massage",
  description: "Clinical tissue work designed to release deep tension, improve circulation, and complement your chiropractic care plan.",
  icon: UserPlus,
  link: "/TreatmentsPage"
}, {
  title: "Dry Needling Therapy",
  description: "Precision techniques for muscle pain and trigger point release, performed by our highly certified clinical specialists.",
  icon: Syringe,
  link: "/ConditionTreatmentPage"
}, {
  title: "Limassol & Nicosia Clinics",
  description: "Two modern, welcoming locations serving both the local Cypriot community and international expats with excellence.",
  icon: Building2,
  link: "/ChiropractorNicosiaClinicPage"
}];
export default function ServiceCards() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="171754" id="practitionerspotlight" className="section bg-background text-foreground">
      <div className="container max-w-7xl mx-auto">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-12 md:mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold text-foreground mb-4 tracking-tight">
            Our Expert Practitioners
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl font-sans">
            Meet the dedicated clinical team at Bodywerks, providing world-class chiropractic and acupuncture care across Cyprus.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, i) => {
          const {
            ref: cardRef,
            isVisible: isCardVisible
          } = useRevealOnScroll({
            threshold: 0.1
          });
          return <div key={i} data-index={i} ref={cardRef} className={`transition-all duration-700 ease-out ${isCardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full flex flex-col bg-card/60 backdrop-blur-md border-border/40 rounded-[16px] shadow-lg hover:shadow-xl transition-shadow duration-300">
                  <CardHeader className="pb-4">
                    <div className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center mb-4 shadow-sm border border-accent/20">
                      <service.icon className="w-6 h-6 text-accent stroke-[2px]" />
                    </div>
                    <CardTitle className="font-serif text-2xl text-foreground">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow">
                    <CardDescription className="font-sans text-base text-muted-foreground leading-relaxed">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                  <CardFooter className="pt-2 pb-6">
                    <Button asChild variant="default" className="w-full group font-sans font-medium rounded-full bg-primary text-primary-foreground hover:bg-primary/90 transition-all">
                      <Link to={service.link}>
                        View Profile
                        <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" />
                      </Link>
                    </Button>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}